import { CmsApiError } from '@/services/cmsApiClient';
import type { CmsGender } from '@/types/registration';

const CMS_GENDERS: CmsGender[] = ['male', 'female', 'other', 'unknown'];

const TERMINAL_POLL_STATUSES = new Set([401, 403, 404, 422]);

const toCmsGender = (gender: string): CmsGender => {
  const normalised = gender.trim().toLowerCase();
  return CMS_GENDERS.find((g) => g === normalised) ?? 'unknown';
};

const errStatus = (err: unknown): string | number =>
  err instanceof CmsApiError ? (err.status ?? 'unknown') : 'unknown';

const pollErrStatus = (err: unknown): number | undefined =>
  err instanceof CmsApiError ? err.status : undefined;

const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export { TERMINAL_POLL_STATUSES, errStatus, pollErrStatus, sleep, toCmsGender };
